export const BOOKINGS = 'BOOKINGS';
export const AVAILABILITIES = 'AVAILABILITIES';
